import { useState, useEffect, useMemo } from 'react';
import '../../asset/styles/research-reposts-style.css';
import { siderWidth } from '../../../constants/layout'
import { contentPadding } from '../../layouts/layoutHelper';

import ResearchReportTbl from '../../tables/ResearchReportTbl';

import api from '../../../apis';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { useLoading } from '../../../context/LoadingContext';

import CardList from '../../general/card-list';
import Modal from '../../general/modal';

import Config from '../../../config';

import EventArticle from '../../general/article/eventArticle';


import event1 from '../../asset/images/event/1101.png';

import useAuth from '../../../hooks/useAuth';

import { DatePicker, Pagination } from 'antd';
import MotionLayout from '../../general/framer-motion/MotionLayout';
import { FilterProvider } from '../../../context/FilterContext';
import CloseButton from '../../layouts/CloseButton';
import FilterInputBuilder from '../../filterInputBuilder/userFilter';
import OpenButton from '../../layouts/OpenButton';
const { RangePicker } = DatePicker;

const Index = () => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);

    const { state } = useLocation();
    const { setLoading } = useLoading();
    const [modelProps, setModelProps] = useState({});
    const [researchTypes, setResearchTypes] = useState<any>([]);
    const [reportList, setReportList] = useState([]);

    const [inputs, setInputs] = useState({ paymentType: '' });
    const [openModel, setOpenModel] = useState(false);

    const [cResearchType, setcResearchType] = useState<any>(null);
    const [dateStart, setDateStart] = useState<any>(null);
    const [dateEnd, setDateEnd] = useState<any>(null);
    const [cTerm, setcTerm] = useState<any>(null);
    const [cExchange, setcExchange] = useState<any>([]);
    const [cStock, setcStock] = useState<any>([]);
    const [cPage, setcPage] = useState<any>(1);
    const [totalRecord, setTotalRecord] = useState<any>(10);
    
    const { auth, setAuth } = useAuth();

    const filterColumns = [
        {
            type:"selectResearchType",
        },
      
        {
            type: "selectExchangeAndStock",
        },
        {
            type:"selectDateRangePicker"
        },
    ]


    useEffect(() => {
       // getResearchCategory();

      getResearchCategoryList();
    }, []);

    useEffect(() => {
        console.log(inputs);
        // if (currentAccNo) {
        //     requestGetAccountContractAPI(currentAccNo, searchInputs);
        // }
    }, [inputs]);

    // useEffect(() => {
    //     getResearchCategoryList();
    // }, [cResearchType, cPage]);

    // useEffect(() => {
    //     getResearchCategoryList();
    // }, [dateEnd]);

    // useEffect(() => {
    //     //typing delay
    //     const delayDebounceFn = setTimeout(() => {
    //         if (cTerm) {
    //             //pass keyin change to parent
    //             getResearchCategoryList();
    //         }
    //     }, 700);
    //     return () => clearTimeout(delayDebounceFn);
    // }, [cTerm]);
    // useEffect(() => {
    //     const delayDebounceFn = setTimeout(() => {
    //         getResearchCategoryList();
    //     }, 1000);
    //     return () => clearTimeout(delayDebounceFn);
    // }, [cExchange, cStock]);

    // const getResearchCategory = () => {
    //     const { b_id } = state || {};

    //     setLoading(true);
    //     api.getResearchCategory().then((result: any) => {
    //         if (result) {
    //             console.log("setResearchTypes",result)
    //             setResearchTypes(result);
    //             getResearchCategoryList(b_id);
    //         }
    //     });
    // };

    const getResearchCategoryList = (c_b_id = null) => {
        setLoading(true);

        api.getResearchList({
            page: cPage,
            category: parseInt(cResearchType),
            dateStart: dateStart?.date,
            dateEnd: dateEnd?.date,
            term: cTerm?.value,
            exchanges: cExchange,
            stocks: cStock
        }).then((result: any) => {
           // console.log('getResearchList', result);
            if (result.total) {
                setTotalRecord(result.total);
            }
            if (result.researches) {
              //  console.log('result.researches', result.researches);

                let arrData = [];
                let list = result.researches;
                for (var i = 0; i < list.length; i++) {
                    let row = list[i];

                    let title = row.category + ' - ' + row.title;
                    let b_publish_date_start = row.b_publish_date_start || null;
                    let description = row.description;
                    let file_thumbnail = row.file_thumbnail
                        ? Config.publicFileUrl + row.file_thumbnail
                        : event1;
                    let file_content = row.file_content;
                    let htmlfile =
                        Config.publicFileUrl + file_content + '#toolbar=0&navpanes=0';
                    let b_id = row.b_id;
                    let sourceText = row.source ? row.source + ' • ' : '';
                    let obj = {
                        img: file_thumbnail,
                        date: moment(b_publish_date_start).format(
                            'MMM DD YYYY'
                        ),
                        b_publish_date_start: b_publish_date_start,
                        title: title,
                        subTitle: (
                            <>
                                {sourceText +
                                    moment(b_publish_date_start).format(
                                        'DD MMM YYYY'
                                    )}
                                {/* Bursa Malaysia • 22 Jul 2022 */}
                            </>
                        ),
                        desc: description,
                        file_content: htmlfile,
                        source: row.source,
                        category: row.category,
                        file_type: 'research',
                        layout: auth.layout,
                        b_id
                    };
                    arrData.push(obj);

                    if (b_id == c_b_id) {
                        //selected article
                        setModelProps(obj);
                        setOpenModel(true);
                    }
                }
                setReportList(arrData);
            }

            setLoading(false);
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
    };

    const onDateChange = ({ id, timestamp }: any) => {
        let cdate = '';
        if (timestamp) {
            cdate = moment(timestamp, 'DD-MM-YYYY').format('YYYY-MM-DD');
        }

       // console.log('id, timestamp', id, timestamp);
        //  onDropdownChange(id, cdate);
        if (id == 'dateStart') {
            setDateStart({ id, date: cdate });
        } else if (id == 'dateEnd') {
            setDateEnd({ id, date: cdate });
        }
    };

    const onTermChange = (id: string, value: string) => {
        setcTerm({ id, value });
    };
    const onExchangeChange = (value: any) => {
        setcExchange(value);
    };
    const onStockChange = (value: any) => {
        setcStock(value);
    };



    const handleArticle = (row: any) => {
       // console.log(row);
        setOpenModel((oldValue) => true);
        setModelProps(row);
    };

    const onPaginationChange = (page: any) => {
        setcPage(page);
    };

    const handleSidebarToggle = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };


    return (
        <MotionLayout>
            <FilterProvider>
            <div className={`page-layout  ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className="side-bar" style={{
                        width: isSidebarCollapsed ? '0' : siderWidth
                    }}>
                        <CloseButton 
                            handleClick={handleSidebarToggle}
                        />
                        <div className='content' style={{width:siderWidth}}>
                            <div className='pt-3'></div>
                         
                            <FilterInputBuilder 
                                loading={tableLoading}
                                columns={filterColumns} 
                                initSearchWhenReceived={[`accounts[]`]}  
                                onSearchSubmit={(inputs:any)=>{
                               
                                    //force trigger search
                                    setInputs(JSON.parse(JSON.stringify(inputs)));
                                // console.log("12345 contra!!!! set filter "+JSON.stringify(inputs))
                                    //setFilterParams("contra",JSON.parse(JSON.stringify(inputs)));
                                }}
                            />
                         
                        </div>
                    
                    </div>
                    <div className="main-content " style={{
                        marginLeft: isSidebarCollapsed ? '0px' : siderWidth,
                        paddingLeft: isSidebarCollapsed ? '0px' : '20px',
                    }}>
                        <OpenButton 
                            isSidebarCollapsed={isSidebarCollapsed}
                            handleClick={handleSidebarToggle}
                        />
                        <div className={ contentPadding(isSidebarCollapsed)}>
                            <div className="main-title ">Research Reports</div>
                            <ResearchReportTbl />
                    
                        </div>
                        
                    
                    </div>
                </div>
              
            </FilterProvider>
        </MotionLayout>
    );
};

export default Index;
